import clsx from 'clsx';
import * as React from 'react';
import useDraft from '../hooks/useDraft';
import { useEditor } from '../hooks/useEditor';
import useKites from '../hooks/useKites';
import SaveIcon from '../icons/SaveIcon';

export default function EditorHeader() {
    const { count } = useKites();
    const { draft } = useDraft();
    const {
        editor: { draftSaved },
        save,
    } = useEditor();

    return (
        <div className="kite__header">
            <div className="kite__header__section">
                <div className="kite__title">{draft.name}</div>
                <button
                    className={clsx('button button--small', {
                        warning: !draftSaved,
                    })}
                    onClick={() => save(draft.id)}
                    disabled={count > 0 ? draftSaved : false}
                >
                    <SaveIcon />
                    save
                </button>
            </div>
        </div>
    );
}
